export default "__VITE_ASSET__30320ea7__"